import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, LogOut, Settings } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import UserRoleDisplay from "@/lib/auth/UserRoleDisplay";

interface UserAvatarMenuProps {
  displayName: string;
  email: string;
  onLogout: () => void;
  isLoggingOut?: boolean;
}

export const UserAvatarMenu = ({
  displayName,
  email,
  onLogout,
  isLoggingOut = false,
}: UserAvatarMenuProps) => {
  const { t } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="relative p-0 h-10 w-10 md:h-8 md:w-8 rounded-full bg-gray-200"
        >
          <User className="h-5 w-5 md:h-4 md:w-4 text-gray-600" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64" align="end" forceMount>
        <div className="flex flex-col gap-2 p-2">
          <div className="flex items-center gap-3">
            <div className="flex flex-col leading-none min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{displayName}</p>
              <p className="text-xs text-muted-foreground truncate">{email}</p>
            </div>
          </div>
          <div className="flex justify-start">
            <UserRoleDisplay />
          </div>
        </div>
        <DropdownMenuSeparator />
        {/* <DropdownMenuItem asChild>
          <Link to="/profile" className="cursor-pointer">
            <User className="mr-2 h-4 w-4" />
            <span className="text-xs">{t("navigation.profile")}</span>
          </Link>
        </DropdownMenuItem> */}
        <DropdownMenuItem asChild>
          <Link to="/profile?tab=account-settings" className="cursor-pointer">
            <Settings className="mr-2 h-4 w-4" />
            <span className="text-xs">{t("settings.accountSettings")}</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={onLogout}
          disabled={isLoggingOut}
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span className="text-xs">
            {isLoggingOut ? t("auth.loggingOut") : t("auth.logout")}
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
